export const SET_STATUS = (state, payload) => {
    state.status = payload
}

export const SET_LOADING = (state, payload) => {
    state.loading = payload
}